import { Link } from "@tanstack/react-router";

import ModalCloseIcon from "@/components/icons/modal-close-icon";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
} from "@/components/ui/dialog";
import usePWA from "@/hooks/use-pwa";
import { cn } from "@/lib/utils";

import { MortyIcon } from "./icons";

export interface WrapperModalProps extends React.ComponentProps<typeof Dialog> {
  bodyClassName?: string;
  className?: string;
  closeIcon?: React.ReactElement;
  hideCloseButton?: boolean;
  overlayClassName?: string;
  title?: string;
}

export default function WrapperModal({
  bodyClassName,
  className,
  closeIcon,
  children,
  hideCloseButton = false,
  overlayClassName,
  title,
  ...props
}: WrapperModalProps) {
  const { homeHref } = usePWA();

  return (
    <Dialog {...props}>
      <DialogContent
        className={cn(
          "block min-h-full w-full max-w-none border-0 bg-[url(/images/main-bg.jpg)] bg-cover bg-top bg-no-repeat md:min-h-auto md:min-w-100 md:rounded-[25px]",
          className
        )}
        overlayClassName={cn("items-start bg-black/50", overlayClassName)}
      >
        <DialogHeader className="relative shrink-0 items-center border-navy-gray border-b py-5 font-semibold text-16/[1.5em] text-white">
          {!hideCloseButton && (
            <DialogClose className="group absolute top-1/2 left-6 flex size-[25px] -translate-y-1/2 items-center justify-center rounded-full border border-white transition-colors hover:bg-white">
              {closeIcon || (
                <ModalCloseIcon className="transition-colors group-hover:text-dark-magenta" />
              )}
            </DialogClose>
          )}
          {title || (
            <DialogClose asChild>
              <Link to={homeHref}>
                <MortyIcon />
              </Link>
            </DialogClose>
          )}
        </DialogHeader>
        <div className={cn("p-6", bodyClassName)}>{children}</div>
      </DialogContent>
    </Dialog>
  );
}
